'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobCarousel', cobCarousel);

	cobCarousel.$inject = ['$location', 'sessionService', 'observerService', 'subjectObserverMessagesService'];

	var $location, sessionService, observerService, subjectObserverMessagesService, subjectMessages, observerMessages;
	var CSS = {
		modalOverlay: '.ui-widget-overlay',
		dialogContainer: '#carouselDialogContainer',
		dialogFooter: {
			container: '#carouselDialogFooter',
			backArrowContainer: '#carouselDialogFooter span:eq(0)',
			controlsContainer: '#carouselDialogFooter span:eq(1)',
			forwardArrowContainer: '#carouselDialogFooter span:eq(2)'
		},
		carouselContainer: '#carouselContainer',
		menuItemTrigger: '#open_carousel_dialog'
	};

	function cobCarousel(_$location_, _sessionService_, _observerService_, _subjectObserverMessagesService_) {

		sessionService = _sessionService_;
		observerService = _observerService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		$location = _$location_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			link: linkFunction,
			templateUrl: '/app/common/directives/cobCarousel.html'
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
            
			registerEventHandlers();

			scope.images = {
				whatsNew: buildImageSrc('1-whatsnew.png'),
				compactView: buildImageSrc('2-compactview.png'),
				preferBlock: buildImageSrc('3-preferblock.png'),
				filters: buildImageSrc('4-filters.png'),
				responsiveScreenshot: buildImageSrc('5-responsiveScreenshot.png'),
				helpCenter: buildImageSrc('6-helpCenter.png'),
				hotMarketMap: buildImageSrc('6-hotMarketMap.png'),
				tools: buildImageSrc('6-tools.png'),
				trendlines: buildImageSrc('6-trendlines.png'),
				zipZoneMap: buildImageSrc('6-zipZoneMap.png')
			};

			scope.urls = {
				trainingVideos: 'foo',
				webPageZoomVideo: 'foo',
				searchTrucksVideo: 'foo',
				searchLoadsVideo: 'foo'
			};

			if ($location.path() === '/carriers'
                && sessionService.isBroker()
                && !sessionService.isAuthorizedInternalAdmin()
                && !sessionService.isCarrier()) {
				if (!isFirstTimeShown()) {
					// Uncomment this to make modal popup on login screen
					showCarouselModal(); 
					setFirstTimeShown();
				}
			}

		}

		function buildImageSrc(imgSrc) {
			return '/app/images/carousel/' + imgSrc;
		}

		function isFirstTimeShown() {
			return sessionService.getCarouselViewed();
		}

		function setFirstTimeShown() {
			sessionService.setCarouselViewed();
		}

		function showCarouselModal() {
			$(CSS.dialogContainer).dialog({
				modal: true,
				height: 460,
				width: 900,
				resizable: false,
				show: { effect: 'fade', duration: 300 },
				hide: { effect: 'fade', duration: 300 },
				draggable: false,
				dialogClass: 'carouselDialog'
			});

			$(CSS.carouselContainer).anythingSlider({
				theme: 'DAT',
				resizeContents: true,
				easing: 'swing',
				buildStartStop: false,
				appendBackTo: $(CSS.dialogFooter.backArrowContainer),
				appendControlsTo: $(CSS.dialogFooter.controlsContainer),
				appendForwardTo: $(CSS.dialogFooter.forwardArrowContainer),
				appendNavigationTo: null,
				appendStartStopTo: null,
				toggleArrows: false,
				toggleControls: false,
				forwardText: '',
				backText: '',
				hashTags: false,
				navigationFormatter: function () {
					return '';
				},
				animationTime: 300
			});

			registerInteractionEvents();
		}

		function registerInteractionEvents() {
			$(CSS.modalOverlay).on('click', function () {
				$(CSS.dialogContainer).dialog('close');
			});
		}

		function registerEventHandlers() {
			$(CSS.menuItemTrigger).on('click', showCarouselModal);

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_CAROUSEL_REQUEST_OPEN, handler: showCarouselModal }
				]);
		}      
	}
})();
